import $ from 'jquery';

$(function () {
  var companyId = $('.js-spam-email-autocomplete input').data('companyId');
  $('.js-spam-email-autocomplete input').autocomplete({
    source: '/admin/companies/' + companyId + '/spam_tests/emails',
  });
});
